(function() {
  const initializedCarousels = new WeakMap();

  function initCarousel(carouselElement) {
    if (!carouselElement) return;
    
    // Skip if already initialized
    if (initializedCarousels.has(carouselElement)) return;

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(carouselElement), 100);
      return;
    }

    const embla = EmblaCarousel(carouselElement, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: 1,
      dragFree: false
    });

    initializedCarousels.set(carouselElement, embla);

    const prevButton = carouselElement.closest('.nf-leadgen-carousel')?.querySelector('.nf-leadgen-carousel__button--prev');
    const nextButton = carouselElement.closest('.nf-leadgen-carousel')?.querySelector('.nf-leadgen-carousel__button--next');
    const dotsContainer = carouselElement.closest('.nf-leadgen-carousel')?.querySelector('.nf-leadgen-carousel__dots');
    const slides = carouselElement.querySelectorAll('.nf-leadgen-carousel__slide');

    const setupDots = () => {
      if (!dotsContainer) return;
      
      dotsContainer.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'nf-leadgen-carousel__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsContainer.appendChild(dot);
      });
    };

    const updateDots = () => {
      const selectedIndex = embla.selectedScrollSnap();
      const dots = dotsContainer?.querySelectorAll('.nf-leadgen-carousel__dot');
      dots?.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add('nf-leadgen-carousel__dot--active');
        } else {
          dot.classList.remove('nf-leadgen-carousel__dot--active');
        }
      });
    };

    const updateSlides = () => {
      const selectedIndex = embla.selectedScrollSnap();
      slides.forEach((slide, index) => {
        if (index === selectedIndex) {
          slide.classList.add('nf-leadgen-carousel__slide--active');
        } else {
          slide.classList.remove('nf-leadgen-carousel__slide--active');
        }
      });
    };

    const updateButtons = () => {
      if (prevButton) {
        prevButton.disabled = !embla.canScrollPrev();
      }
      if (nextButton) {
        nextButton.disabled = !embla.canScrollNext();
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => embla.scrollPrev());
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => embla.scrollNext());
    }

    embla.on('select', () => {
      updateDots();
      updateButtons();
      updateSlides();
    });

    embla.on('init', () => {
      setupDots();
      updateDots();
      updateButtons();
      updateSlides();
    });

    setupDots();
    updateDots();
    updateButtons();
    updateSlides();
  }

  function initAllCarousels() {
    const carousels = document.querySelectorAll('.nf-leadgen-carousel__viewport:not([data-initialized])');
    carousels.forEach((carousel) => {
      carousel.setAttribute('data-initialized', 'true');
      initCarousel(carousel);
    });
  }

  function handleThemeEditorUpdates() {
    // Listen for theme editor DOM updates
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initAllCarousels);
      document.addEventListener('shopify:section:reorder', initAllCarousels);
      document.addEventListener('shopify:block:select', initAllCarousels);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      handleThemeEditorUpdates();
    });
  } else {
    initAllCarousels();
    handleThemeEditorUpdates();
  }

  // Use MutationObserver for theme editor updates
  if (window.Shopify?.designMode) {
    const observer = new MutationObserver(() => {
      initAllCarousels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

